import { useMemo } from 'react';
import { useProjectState, useUnit } from '@starflow/app/store';

export const useDerivativeTasks = (unitId) => {
  const tasks = useProjectState('tasks');
  const unit = useUnit(unitId);
  const results = unit?.result?.items || [];
  const { map, current, fe_queue } = tasks;
  const currentTask = current && map[current]?.unitId === unitId ? map[current] : null;
  const pendingTasks = fe_queue.filter((task) => task.unitId === unitId);

  return useMemo(() => {
    let tasks = [];

    pendingTasks.forEach((item) => {
      tasks = tasks.concat(
        Array.from({ length: item.params?.count || 1 }).map((_, index) => ({
          id: `${item.id}-${index}`,
          type: 'queue',
          queueId: item.id,
        })),
      );
    });

    if (currentTask) {
      tasks = tasks.concat(
        currentTask.results.map((item) => ({
          id: item.id,
          type: 'task',
          taskId: currentTask.taskId,
          status: currentTask.status,
          progress: currentTask.progress,
          queueIndex: currentTask.queueIndex,
          queueLength: currentTask.queueLength,
          isAccelerating: currentTask.isAccelerating,
        })),
      );
    }

    return tasks.concat(
      results.map((item) => {
        return {
          id: item.id,
          url: item.url,
          innerTaskId: item.innerTaskId,
          innerImageId: item.innerImageId,
          width: item.width,
          height: item.height,
          data: item.data,
        };
      }),
    );
  }, [currentTask, pendingTasks, results]);
};
